import en from './en.js';
import it from './it.js';

const modules = { en, it };

export default modules;
